module.exports = __webpack_public_path__ + "img/credit_red_icon.70b2adfd.svg";